import React, { useState, useEffect } from 'react';
import NavDesktop from '../NavDesktop';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index";
import DrawerToggleButton from '../SideDrawer/DrawerToggleButton';
import './Toolbar.css';

const Toolbar = (props) => {
    const [isMenuVisible, setMenuVisible] = useState(true);

    useEffect(() => {
        if (!isMenuVisible) {
            // Ensure any potential focus is removed from UserWay menu when hidden
            const accessibilityMenu = document.querySelector(".mobile-AccessibilityMenu-show");
            if (accessibilityMenu) {
                accessibilityMenu.style.display = "none";
            }
        } else {
            const accessibilityMenu = document.querySelector(".mobile-AccessibilityMenu-show");
            if (accessibilityMenu) {
                accessibilityMenu.style.display = "block";
            }
        }
    }, [isMenuVisible]);

    const handleDrawerToggle = () => {
        setMenuVisible(false); // Hide accessibility menu
        if (props.drawerClickHandler) {
            props.drawerClickHandler();
        }
    };

    return (
        <header className="toolbar">
            <nav className='toolbar_nav'>
                <Navbar.Brand className="mr-sm-4 d-flex mobileLogo" as={Link} to="./">
                    <Image 
                        className="img-fluid" 
                        srcSet="./assest/logo-sm.png 250w, 
                                ./assest/logo-md.png 350w, 
                                ./assest/logo-business.png 456w" 
                        sizes="(max-width: 580px) 250px,
                               (max-width: 780px) 350px,
                                456px"
                        src="./assest/logo-business.png" 
                        alt="Sun West Mortgage Company, Inc. Logo" 
                    />
                    <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="white" width={40} height={40}/>
</div>
                </Navbar.Brand>
                
                <div className="toolbar_toggle-button">
                    <DrawerToggleButton click={handleDrawerToggle} />
                </div>
                <NavDesktop setModalShow={props.setModalShow} />
            </nav>
            
            
        </header>
    );
};

export default Toolbar;
